<template>
    <div>
        <template v-if="uiStore.isMobile || uiStore.isTablet || !rightImages">
            <div class="content-container">
                <div class="small text-uppercase mb-2" v-if="property.city && property.state">
                    {{ property.city }}, {{ property.state }} {{ (property.country && (property.country != 'US')) ? ', '+property.country : '' }}
                </div>
                <h1>{{ property.name }}</h1>

                <div v-if="property.serviceLevel == 'W'" class="mt-4 d-flex align-items-center text-muted clickable" @click="showMarquisModal=true">

                    <div style="width:42px; height:42px;" class="me-3">
                        <marquis-circle-icon/>
                    </div>

                    <div>
                        <div>Marquis Collection Property</div>
                        <div class="small">Find out what it means</div>
                    </div>

                </div>
            </div>

            <div v-if="firstImage" class="position-relative vh-40 mt-3">
                <div class="position-absolute top-0 end-0 p-2 d-flex">
                    <div class="clickable text-primary hover-text-white me-2 text-center bg-body border rounded-circle d-flex align-items-center justify-content-center" style="width:32px; height:32px;" @click="share">
                        <share-icon :size="20"/>
                    </div>
                    <div class="clickable text-primary hover-text-white text-center bg-body border rounded-circle d-flex align-items-center justify-content-center" style="width:32px; height:32px;">
                        <travelers-fav-properties-icon :property="property" :size="14"/>
                    </div>
                </div>
                <lazy-image :src="firstImage.source" height="100%" class="clickable" @click="() => showGallery(0)" :autoLoad="true"/>
            </div>

            <div class="d-flex align-items-start mt-3 content-container">
                <ui-button @click="() => showGallery(0)" :outline="true" class="me-3">
                    Show All Photos
                </ui-button>

                <tour-icon v-if="tourIndex >= 0" class="clickable text-primary me-3" :size="40" @click="() => showGallery(tourIndex)" />
                <video-icon v-if="videoIndex >= 0" class="clickable text-primary me-3" :size="40" @click="() => showGallery(videoIndex)" />
                <layout-icon v-if="layoutIndex >= 0" class="clickable text-primary" :size="40" @click="() => showGallery(layoutIndex)" />
            </div>
        </template>

        <div v-else class="content-container">
            
            <container>
                <row class="mb-3">
                    <column :col="12">
                        <div class="small text-uppercase mb-2" v-if="property.city && property.state">
                            {{ property.city }}, {{ property.state }} {{ (property.country && (property.country != 'US')) ? ', '+property.country : '' }}
                        </div>
                        <h1>{{ property.name }}</h1>
                    </column>

                    <column :col="8">

                        <div v-if="property.serviceLevel == 'W'" class="mt-4 d-flex align-items-center text-muted clickable" @click="showMarquisModal=true">

                            <div style="width:42px; height:42px;" class="me-3">
                                <marquis-circle-icon/>
                            </div>

                            <div>
                                <div>Marquis Collection Property</div>
                                <div class="small">Find out what it means</div>
                            </div>

                        </div>
                    </column>

                    <column :col="4">
                        <div class="mt-4 d-flex align-items-center justify-content-end">
                            <div class="clickable text-primary hover-text-white me-3 text-center" @click="share">
                                Share&nbsp;
                                <share-icon/>
                            </div>

                            <travelers-fav-properties-icon :property="property" :showLabel="true" class="text-center"/>
                        </div>
                        
                    </column>

                </row>
                <row>
                    <column :col="12">

                        <div class="overflow-hidden position-relative h-100 rounded">
                            <lazy-image v-if="firstImage" :src="firstImage.source" height="100%" class="rounded clickable" @click="() => showGallery(0)" :autoLoad="true"/>

                        </div>

                    </column>
                    <column :col="12" >

                        <container>
                            <row>
                                <column v-for="(imgData, index) in rightImages" :key="`property-${property.id}-header-side-images-${index}`" :col="12">
                                    <div class="overflow-hidden position-relative rounded mb-4">

                                        <transition name="fade-transition-scale" @after-enter="switchImage">

                                            <lazy-image v-if="nextImage && (nextImageKey == index)" :src="nextImage.source" class="rounded clickable aspect-ratio-4x3" @click="() => showGallery(nextImage.index)" :autoLoad="true"/>

                                        </transition>

                                        <lazy-image :src="imgData.source" class="rounded clickable aspect-ratio-4x3" @click="() => showGallery(imgData.index)" :autoLoad="true"/>
                                    </div>
                                </column>
                            </row>
                        </container>

                        <div class="d-flex align-items-center">
                            <ui-button @click="() => showGallery(0)" :outline="true" class="me-3">
                                Show All Photos
                            </ui-button>

                            <tour-icon v-if="tourIndex >= 0" class="clickable text-primary me-3" :size="36" @click="() => showGallery(tourIndex)" />
                            <video-icon v-if="videoIndex >= 0" class="clickable text-primary me-3" :size="36" @click="() => showGallery(videoIndex)" />
                            <layout-icon v-if="layoutIndex >= 0" class="clickable text-primary" :size="36" @click="() => showGallery(layoutIndex)" />
                        </div>
                    </column>
                </row>
            </container>
        </div>

        <property-share-modal v-if="showShareModal" :property="property" :open="shareModalOpen" @close="closeShare"/>
        <marquis-modal v-if="showMarquisModal" @close="showMarquisModal=false"/>
    </div>
</template>

<script type="text/javascript">
    import TourIcon from '@/assets/icons/360-circle.svg.vue';
    import VideoIcon from '@/assets/icons/video-circle.svg.vue';
    import LayoutIcon from '@/assets/icons/layout-circle.svg.vue';
    import ShareIcon from '@/assets/icons/share.svg.vue';
    import MarquisCircleIcon from '@/assets/logos/marquis-circle-icon.svg.vue';

    import TravelersFavPropertiesIcon from '@/components/Content/Travelers/Properties/FavoriteIcon.vue';
    import MarquisModal from '@/components/Content/Public/Properties/MarquisModal.vue';
    import PropertyShareModal from '@/components/Content/Public/Properties/ShareModal.vue';
    import CommonComponents from '@/components/Common.vue';
    import ApiObject from '@/classes/ApiObject.js';
    import Utilities from '@/classes/Utilities.js';
    import ApiConfig from '@/config/api.json';

    import { UseUIStore } from '@/store/UI.js';

    export default {
        components: {
            TourIcon,
            VideoIcon,
            LayoutIcon,
            MarquisCircleIcon,
            ShareIcon,
            MarquisModal,
            PropertyShareModal,
            TravelersFavPropertiesIcon,
            ...CommonComponents,
        },

        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },

        data() {
            return {
                showMarquisModal: false,

                firstImage: null,
                rightImages: null,

                disposed: false,
                imageTimer: null,
                nextImage: null,
                nextImageKey: null,
                nextKeyIndex: null,

                shareModalOpen: true,
                showShareModal: false,
            };
        },

        props: {
            property: {
                type: ApiObject,
                required: true,
            },

            galleryMedia: {
                type: Array,
                required: true,
            },
        },

        emits: ['openGallery'],

        created() {

            if (this.allImages) {
                for (let i=0; i<this.allImages.length; i++) {
                    if (!this.firstImage) {
                        this.firstImage = this.allImages[i];
                    }
                    else {
                        if (!this.rightImages) {
                            this.rightImages = [];
                        }

                        this.rightImages.push(this.allImages[i]);
                        if (this.rightImages.length >= 4) {
                            break;
                        }
                    }
                }
            }

            this.imageTimer = setTimeout(this.rotateImage, 5000);
        },

        beforeUnmount() {
            clearTimeout(this.imageTimer);
            this.disposed = true;
        },

        computed: {
            allImages() {
                let re = [];

                if (
                    (this.galleryMedia) &&
                    (this.galleryMedia.length)
                ) {

                    let k = 0;
                    for (let i=0; i<this.galleryMedia.length; i++) {
                        if (
                            (this.galleryMedia[i].type == 'image') &&
                            (this.galleryMedia[i].thumbnail)
                        ) {
                            if ((this.galleryMedia[i].data) && (this.galleryMedia[i].data.floorPlan)) {
                                continue;
                            }
                            re.push({
                                index: i,
                                i: k,
                                source: this.galleryMedia[i].thumbnail,
                            });
                            k++;
                        }
                    }
                    
                }

                if (re.length) {
                    return re;
                }
                return null;
            },

            videoIndex() {
                if (
                    (this.galleryMedia) &&
                    (this.galleryMedia.length)
                ) {
                    for (let i=0; i<this.galleryMedia.length; i++) {
                        if (this.galleryMedia[i].type == 'video') {
                            return i;
                        }
                    }
                }

                return -1;
            },

            tourIndex() {
                if (
                    (this.galleryMedia) &&
                    (this.galleryMedia.length)
                ) {
                    for (let i=0; i<this.galleryMedia.length; i++) {
                        if (this.galleryMedia[i].type == 'tour') {
                            return i;
                        }
                    }
                }

                return -1;
            },

            layoutIndex() {
                if (
                    (this.galleryMedia) &&
                    (this.galleryMedia.length)
                ) {
                    for (let i=0; i<this.galleryMedia.length; i++) {
                        if ((this.galleryMedia[i].data) && (this.galleryMedia[i].data.floorPlan)) {
                            return i;
                        }
                    }
                }

                return -1;
            }
        },

        methods: {
            showGallery(index) {
                this.$emit('openGallery', index);
            },

            rotateImage() {
                clearTimeout(this.imageTimer);
                if ((!this.allImages) || (this.disposed)) return;

                // if we have less than 20 images, don't rotate
                if (this.allImages.length < 20) {
                    return;
                }
                
                let keys = [];
                let skipIndex = [];

                if (this.firstImage) {
                    skipIndex.push(this.firstImage.i);
                }
                if (
                    (!this.uiStore.isMobile) && 
                    (!this.uiStore.isTablet) &&
                    (this.rightImages)
                ) {
                    for (let i=0; i<this.rightImages.length; i++) {
                        keys.push(i);
                        skipIndex.push(this.rightImages[i].i);
                    }
                }

                let keyIndex;

                // eslint-disable-next-line
                while(true) {
                    keyIndex = Utilities.random(0, keys.length - 1);
                    if ((!this.nextKeyIndex) || (this.nextKeyIndex != keyIndex)) {
                        break;
                    }
                }

                this.nextKeyIndex = keyIndex;

                let imageIndex;

                // eslint-disable-next-line
                while (true) {
                    imageIndex = Utilities.random(0, this.allImages.length - 1);

                    // check if any of the current images matches the this index
                    if (skipIndex.indexOf(imageIndex) == -1) {
                        break;
                    }
                }
                
                let nextImage = this.allImages[imageIndex];

                let img = new Image()
                img.onload = function() {

                    this.nextImageKey = keys[keyIndex];
                    this.nextImage = nextImage;

                }.bind(this);

                img.onerror = function() {
                    this.rotateImage();
                }.bind(this);

                img.src = nextImage.source.replace('[PCDN]', ApiConfig.propertyImagesCDN).replace('[CDN]', ApiConfig.imagesCDN);
            },

            switchImage() {
                if (this.nextImage) {
                    if (this.nextImageKey == 'first') {
                        this.firstImage = this.nextImage;
                    }
                    else {
                        this.rightImages[this.nextImageKey] = this.nextImage;
                    }
                }

                this.nextImage = null;
                this.imageTimer = setTimeout(this.rotateImage, 5000);
            },

            share() {
                this.shareModalOpen = true;
                this.showShareModal = true;
            },

            closeShare() {
                this.showShareModal = false;
                this.shareModalOpen = true;
            },
        },
    };

</script>
